// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListContractTypesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ListContractTypesQuery = { __typename?: 'Query' } & {
  listContractTypes: Array<
    { __typename?: 'ContractTypeWithDisplayName' } & Pick<
      Types.ContractTypeWithDisplayName,
      'value' | 'displayName' | 'jobTitleShouldBeEmpty' | 'greenhouseLinkCanBeEmpty'
    > & {
        defaultGoogleWorkspacePlan: Types.Maybe<
          { __typename?: 'GoogleProductAndSKUWithDisplayName' } & Pick<
            Types.GoogleProductAndSkuWithDisplayName,
            'displayName'
          >
        >;
      }
  >;
};

export const ListContractTypesDocument = /*#__PURE__*/ gql`
    query listContractTypes {
  listContractTypes {
    value
    displayName
    jobTitleShouldBeEmpty
    greenhouseLinkCanBeEmpty
    defaultGoogleWorkspacePlan {
      displayName
    }
  }
}
    `;

/**
 * __useListContractTypesQuery__
 *
 * To run a query within a React component, call `useListContractTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListContractTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListContractTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListContractTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListContractTypesQuery, ListContractTypesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListContractTypesQuery, ListContractTypesQueryVariables>(ListContractTypesDocument, options);
}
export function useListContractTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListContractTypesQuery, ListContractTypesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListContractTypesQuery, ListContractTypesQueryVariables>(
    ListContractTypesDocument,
    options,
  );
}
// @ts-expect-error
export function useListContractTypesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListContractTypesQuery, ListContractTypesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListContractTypesQuery, ListContractTypesQueryVariables>;
export function useListContractTypesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListContractTypesQuery, ListContractTypesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListContractTypesQuery | undefined, ListContractTypesQueryVariables>;
export function useListContractTypesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListContractTypesQuery, ListContractTypesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListContractTypesQuery, ListContractTypesQueryVariables>(
    ListContractTypesDocument,
    options,
  );
}
export type ListContractTypesQueryHookResult = ReturnType<typeof useListContractTypesQuery>;
export type ListContractTypesLazyQueryHookResult = ReturnType<typeof useListContractTypesLazyQuery>;
export type ListContractTypesSuspenseQueryHookResult = ReturnType<typeof useListContractTypesSuspenseQuery>;
